import { haveEqualProps } from '@y42/util/have-equal-props';
import { DatasourceTableSettingsGitModel } from './datasource-table/datasource-table-settings.model';

export const areSettingsEqual = (
  a: DatasourceTableSettingsGitModel,
  b: DatasourceTableSettingsGitModel,
  propsToCompare: Array<keyof DatasourceTableSettingsGitModel> = [
    'import',
    'columns',
    '_datos_write_settings',
    'csv_options',
    'default_cursor_field',
  ],
) => {
  return haveEqualProps(a, b, propsToCompare);
};
